import React from "react";
import { BackgroundImage, HeaderComponent } from "../../FifthComponents";
import { ourTeam } from "../../fifthUtils/constant";

const FifthTeam = (props) => {
    const { selectedLanguage, language } = props;
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    return (
        <div>
            <BackgroundImage screenName={selectedLanguage?.txt_our_team_heading} classForBg='fifth-des-team-bg' {...props} />
            <HeaderComponent title={selectedLanguage?.txt_our_team_heading} lineClass='bg-gray' titleClass='color-blue' />
            <div className="fifth-des-team-main">
                <p>
                    ‘{selectedLanguage?.txt_top_care_service}’
                    <br />
                    {selectedLanguage?.txt_team_description}
                </p>
                <div className="fifth-des-team-data-div">
                    {
                        ourTeam?.map((v, i) => {
                            const specialClass = [1, 3, 5, 7].includes(i) ? 'fifth-des-special-class' : '';
                            return (
                                <div key={i} className={specialClass}>
                                    <div className="fifth-des-team-text-div">
                                        <h2>
                                            {isELSelect ? v?.name : (isAlSelect ? v?.alName : v?.glName)}
                                        </h2>
                                        {v?.specialties ? <p>
                                            <strong>
                                                {selectedLanguage?.txt_specialties}
                                            </strong>
                                        </p> : null}
                                        {v?.specialties ? <p>
                                            {isELSelect ? v?.specialties : (isAlSelect ? v?.alSpecialties : v?.glSpecialties)}
                                        </p> : null}
                                        {v?.heading ? <h3>
                                            {isELSelect ? v?.heading : (isAlSelect ? v?.alHeading : v?.glHeading)}
                                        </h3> : null}
                                        {v?.about ? <p>
                                            {isELSelect ? v?.about : (isAlSelect ? v?.alAbout : v?.glAbout)}
                                        </p> : null}
                                    </div>
                                    <div className="fifth-des-team-img-div">
                                        <img src={v?.img} alt="" />
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}
export default FifthTeam